import React from 'react';
import { PIN_OUTLINES } from './pinOutlines';
import type { BearriBadgeName } from './BearriBadge';
import './cardboardCutout.css';

// Precompute once, not per animation frame. Percentage geometry scales with the
// existing header slot; the 3px stock thickness stays legible on small badges.
export const PIN_GEOMETRY = Object.fromEntries(Object.entries(PIN_OUTLINES).map(([name,points]) => [name, {
  clip: `polygon(${points.map(([x,y]) => `${x}% ${y}%`).join(',')})`,
  edges: points.map(([x,y],i) => {
    const [nx,ny] = points[(i+1)%points.length];
    return {left:`${x}%`,top:`${y}%`,width:`${Math.hypot(nx-x,ny-y)}%`,
      transform:`translateZ(-1.5px) rotateZ(${Math.atan2(ny-y,nx-x)*180/Math.PI}deg) rotateX(90deg)`};
  }),
}])) as Record<BearriBadgeName,{clip:string;edges:React.CSSProperties[]}>;

/** Keep both prints mounted: hover must not replace a decoded image with a
 * fresh request. Only the perimeter walls are added during interaction. */
export default function CardboardCutout({name,className='',style,onAnimationEnd,withEdges=true,
  front,backRef,onBackLoad,onBackError}: {
  name:BearriBadgeName;className?:string;style?:React.CSSProperties;
  withEdges?:boolean;front?:React.ReactNode;backRef?:React.Ref<HTMLImageElement>;
  onBackLoad?:React.ReactEventHandler<HTMLImageElement>;
  onBackError?:React.ReactEventHandler<HTMLImageElement>;
  onAnimationEnd?:React.AnimationEventHandler<HTMLSpanElement>;
}) {
  const geometry = PIN_GEOMETRY[name];
  return <span className={`br-cardboard-cutout ${className}`} style={style} aria-hidden="true" onAnimationEnd={onAnimationEnd}>
    {withEdges && geometry.edges.map((edge,i) => <span key={i} className="br-cardboard-cutout__edge" style={edge} />)}
    <span className="br-cardboard-cutout__face br-cardboard-cutout__face--front" style={{clipPath:geometry.clip}}>
      {front || <img src={`/brand/pins/${name}.webp`} alt="" width={512} height={512} draggable={false} />}
    </span>
    <span className="br-cardboard-cutout__face br-cardboard-cutout__face--back" style={{clipPath:geometry.clip}}>
      <img ref={backRef} src={`/brand/pins/${name}.webp`} alt="" width={512} height={512} draggable={false}
        loading="lazy" onLoad={onBackLoad} onError={onBackError} />
    </span>
  </span>;
}
